import { arrayOf, element, eventListener, oneOf, oneOfType, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
import { TabStyle } from '../tab-constants.js';
const TabControlProperties = {
    children: {
        type: oneOfType([element, arrayOf(element)]).notEnumerable(),
    },
    className: {
        type: string,
    },
    defaultTab: {
        type: string,
    },
    onAfterNavigate: {
        type: eventListener,
    },
    onNavigate: {
        type: eventListener,
    },
    style: {
        defaultValue: TabStyle.TEXT_ONLY,
        type: oneOf(enumValues(TabStyle)),
    },
    uuid: {
        defaultValue: '',
        type: string,
    },
};
export { TabControlProperties, };
//# sourceMappingURL=tab-control-types.js.map